enum UserRoles {
  Admin = 'admin',
  Pole = 'pole',
  Relais = 'relais',
  Rh = 'rh',
  PoleCoord = 'pole_coord',
}

export { UserRoles };
